import { render, staticRenderFns } from "./AddProductAlert.vue?vue&type=template&id=bbd760be"
import script from "./AddProductAlert.vue?vue&type=script&lang=js"
export * from "./AddProductAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports